import * as types from './action-types';
import { defineAction } from 'store/common/action-helpers';

export const fetchMyCompanies = {
  start: payload => defineAction(types.FETCH_MY_COMPANIES.START, payload),
  success: ({ input, result }) => defineAction(types.FETCH_MY_COMPANIES.SUCCESS, { input, result }),
  failure: ({ input, error }) => defineAction(types.FETCH_MY_COMPANIES.FAILURE, { input, error }),
};



// WEBPACK FOOTER //
// ./src/store/graphql/AdminFetchMyCompanies/actions.js